// Donation detail page (CHG-1243 / ITER-3366).
//
// Thin per the v9 brief: ≤30 LOC. All configuration in @generated/screens.
// Future generator regenerates donationDetailConfig from
// donation.entity-hint.yaml (CHG-1228) without touching this file.
//
// Spec: specs/tier-05-experience/donation-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { donationDetailConfig } from "../generated/screens/donation-detail";

export function DonationDetail() {
  return <DetailPage config={donationDetailConfig} />;
}
